import React from "react"

export default function CheckBox({ data, changeHandler, result }) {
  const check = (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 4.00004L3.58 6.83004L6.415 4.00004L9.25 1.17004"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )

  return (
    <div className={`hq-form__field`}>
      <label className="hq-form__label" htmlFor={data.id}>
        {data.label}
        {data.isRequired ? <span></span> : ""}
      </label>
      <div>
        <fieldset id={data.id} className="">
          {data.choices.map((c, i) => {
            return (
              <div key={i} className="hq-form__field--checkbox">
                <input
                  type={"checkbox"}
                  id={`${data.id}-${c.value}`}
                  name={data.id}
                  aria-label={c.text}
                  className="hidden"
                  onChange={e => {
                    changeHandler(c.value, `${data.id}.${i + 1}`, data.type)
                  }}
                />
                <label
                  htmlFor={`${data.id}-${c.value}`}
                  className="hq-form__custom--checkbox"
                >
                  {check}
                </label>
                <label
                  className={`hq-form__checkbox--label`}
                  htmlFor={`${data.id}-${c.value}`}
                >
                  {c.text}
                </label>
              </div>
            )
          })}
        </fieldset>
      </div>
    </div>
  )
}
